/** @jsx jsx */
import * as React from "react";
import { isEmpty as _isEmpty } from "lodash";
import { ILabtestPrescription } from "@curefit/care-common";
import AppUtils from "../../../utils/AppUtils";
import { patientConsSummary } from "../../../styles/patient/patientConsSummary";
import { css, jsx } from "@emotion/core";


interface LabTestViewProps {
    labTests: ILabtestPrescription[];
    diagnosticAssessments: any[];
}
const LabTestsView: React.StatelessComponent<LabTestViewProps> = (props: LabTestViewProps) => {
    const isMobile: boolean = AppUtils.getIsMobile();
    if (isMobile) {
        return (
            <div>
                {
                    props.labTests && props.labTests.map((labTest, index) => {
                        return (
                            <div css={patientConsSummary.medicineCard}>
                                <div css={patientConsSummary.medicineName}>{labTest.diagnosis && labTest.diagnosis.displayValue}</div>
                                <span css={patientConsSummary.description}>
                                    {!_isEmpty(labTest.instructions) ? `${labTest.instructions} | ` : ""}
                                </span>
                                <span css={patientConsSummary.description}>
                                    {!_isEmpty(labTest.medicineFrequency) ? labTest.medicineFrequency.count : ""} {!_isEmpty(labTest.medicineFrequency) && !_isEmpty(labTest.medicineFrequency.unit) ? labTest.medicineFrequency.unit.toLowerCase() : ""}
                                </span>
                                <span css={patientConsSummary.description}>
                                    {labTest.comments ? ` | ${labTest.comments}` : ""}
                                </span>
                            </div>
                        )
                    })
                }
            </div>
        )
    }
    return (
        props.labTests ? (<div className={"medicine-prescription-view-container"}>
            <table style={{ tableLayout: "auto", width: "100%" }}>
                <thead>
                    <tr>
                        <th className={"brandon-bold"}>LAB TEST</th>
                        <th className={"brandon-bold"}>CONDITION</th>
                        <th className={"brandon-bold"}>WHEN</th>
                        <th className={"brandon-bold"}>ADDITIONAL INSTRUCTIONS</th>
                    </tr>
                </thead>

                <tbody>
                    {props.labTests && props.labTests.map((labTest, index) => {
                        return <tr key={index}>
                            <td className="highlighted-text">{labTest.diagnosis && labTest.diagnosis.displayValue}</td>
                            <td>{!_isEmpty(labTest.instructions) ? labTest.instructions : ""}</td>
                            <td>{!_isEmpty(labTest.medicineFrequency) ? labTest.medicineFrequency.count : ""} {!_isEmpty(labTest.medicineFrequency) && !_isEmpty(labTest.medicineFrequency.unit) ? labTest.medicineFrequency.unit.toLowerCase() : ""}</td>
                            <td>{labTest.comments}</td>
                        </tr>
                    })}
                </tbody>
            </table>
        </div>
        )
            :
            (
                <div className={"medicine-prescription-view-container"}>
                    <table style={{ tableLayout: "auto", width: "100%" }}>
                        <thead>
                            <tr>
                                <th className={"brandon-bold"}>LAB TEST</th>
                                <th className={"brandon-bold"}>CONDITION</th>
                                <th className={"brandon-bold"}>WHEN</th>
                                <th className={"brandon-bold"}>ADDITIONAL INSTRUCTIONS</th>
                            </tr>
                        </thead>

                        <tbody>
                            {props.diagnosticAssessments && props.diagnosticAssessments.map((diagnosticAssessment, index) => {
                                return <tr key={index}>
                                    <td className="highlighted-text">{diagnosticAssessment.diagnosticTest.displayValue}</td>
                                    <td>{!_isEmpty(diagnosticAssessment.condition) ? diagnosticAssessment.condition : ""}</td>
                                    <td>{!_isEmpty(diagnosticAssessment.diagnosticsDuration) ? diagnosticAssessment.diagnosticsDuration.count : ""} {!_isEmpty(diagnosticAssessment.diagnosticsDuration) && !_isEmpty(diagnosticAssessment.diagnosticsDuration.unit) ? diagnosticAssessment.diagnosticsDuration.unit.toLowerCase() : ""}</td>
                                </tr>
                            })}
                        </tbody>
                    </table>
                </div>
            )
    )

}

export default LabTestsView;